module.exports = __webpack_public_path__ + "img/domain-wheel.48d87b75.svg";